export const initialDevs = [
  {
    device_type: 'counter',
    category: 'Счетчики',
    device_type_i: 0,
    sub: [
      {
        device_type: 'counter:water:cold',
        category: 'Счетчик холодной воды (ХВС)',
        device_subtype_i: 0,
        output_type: [
          {
            i: 0,
            key: 'relay',
            name: 'Геркон',
          },
          {
            i: 1,
            key: 'namur',
            name: 'Намур',
          },
        ],
      },
      {
        device_type: 'counter:water:hot',
        category: 'Счетчик горячей воды (ГВС)',
        device_subtype_i: 1,
        output_type: [
          {
            i: 0,
            key: 'relay',
            name: 'Геркон',
          },
          {
            i: 1,
            key: 'namur',
            name: 'Намур',
          },
        ],
      },
      // {
      //   device_type: 'counter:water',
      //   category: 'Счетчик воды (универсальный)',
      //   device_subtype_i: 2,
      //   output_type: [
      //     {
      //       i: 0,
      //       key: 'relay',
      //       name: 'Геркон',
      //     },
      //     {
      //       i: 1,
      //       key: 'namur',
      //       name: 'Намур',
      //     },
      //   ],
      // },
    ],
  },
  {
    device_type: 'sensor',
    category: 'Датчики',
    device_type_i: 1,
    sub: [
      {
        device_type: 'sensor:water:leakage',
        category: 'Датчик протечки',
        device_subtype_i: 0,
        output_type: [
          {
            i: 0,
            key: 'ws',
            name: 'Датчик протечки (без контроля обрыва)',
          },
          // {
          //   i: 1,
          //   key: 'wsfc',
          //   name: 'Датчик протечки (с контролем обрыва)',
          // },
        ],
      },
      // {
      //   device_type: 'sensor:temperature',
      //   category: 'Датчик температуры',
      //   device_subtype_i: 1,
      //   output_type: [
      //     {
      //       i: 0,
      //       key: 'pt1000',
      //       name: 'Pt1000',
      //     },
      //   ],
      // },
    ],
  },
  {
    device_type: 'controller',
    category: 'Контроллеры',
    device_type_i: 2,
    sub: [
      {
        device_type: null,
        category: 'Контроллер стандартный',
        device_subtype_i: 0,
        output_type: [
          {
            i: 0,
            key: null,
            name: '',
          },
        ],
      },
    ],
  },
];

export const initialCounterSubtype = [
  {
    category: 'Счетчик холодной воды (ХВС)',
    color: '#369bff',
    device_subtype_id: 1,
    device_type: 'counter:water:cold',
  },
  {
    category: 'Счетчик горячей воды (ГВС)',
    color: 'red',
    device_subtype_id: 2,
    device_type: 'counter:water:hot',
  },
  {
    category: 'Счетчик воды (универсальный)',
    color: 'gray',
    device_subtype_id: 3,
    device_type: 'counter:water',
  },
];

export const initialConfiguration = {
  intType: [
    { opt: 'Ежедневно', val: 'D' },
    { opt: 'Еженедельно', val: 'W' },
    { opt: 'Ежемесячно', val: 'M' },
  ],
  writingIntervals: [
    { opt: 'Каждый 1 час', val: 1 },
    { opt: 'Каждые 2 часа', val: 2 },
    { opt: 'Каждые 4 часа', val: 4 },
    { opt: 'Каждые 6 часов', val: 6 },
    { opt: 'Каждые 8 часов', val: 8 },
    { opt: 'Каждые 12 часов', val: 12 },
    { opt: 'Каждые 24 часа', val: 24 },
  ],
  writingIntervalsPerWeek: [
    { opt: 'Каждые 12 часов', val: 12 },
    { opt: 'Каждые 24 часа', val: 24 },
  ],
  writingIntervalsPerMonth: [{ opt: 'Каждые 24 часа', val: 24 }],
  weekDay: [
    { opt: 'Понедельник', val: 1 },
    { opt: 'Вторник', val: 2 },
    { opt: 'Среда', val: 3 },
    { opt: 'Четверг', val: 4 },
    { opt: 'Пятница', val: 5 },
    { opt: 'Суббота', val: 6 },
    { opt: 'Воскресенье', val: 7 },
  ],
  sendHrs: Array.from({ length: 24 }, (_, i) => ({ opt: `${i.toString().padStart(2, '0')}:00`, val: i })),
  channels: Array.from({ length: 8 }, (_, i) => ({ val: i + 1, opt: i + 1 })),
  monthdays: Array.from({ length: 28 }, (_, i) => ({ val: i + 1, opt: i + 1 })),
  multiplier: [
    { val: 1, opt: 1 },
    { val: 10, opt: 10 },
  ],
};

export const waterLeakageStatus = {
  [-1]: 'Ожидание',
  0: 'Норма',
  1: 'Тревога',
};
